<h2 mat-dialog-title>
  {{ isEditMode ? 'Modifier le collaborateur' : 'Nouveau collaborateur' }}
</h2>

<div *ngIf="backendError" class="backend-error-banner">
  <mat-icon>error_outline</mat-icon>
  <span>{{ backendError }}</span>
</div>

<mat-dialog-content class="dialog-content">
  <form [formGroup]="form" class="form">

    <div class="form-row">
      <mat-form-field appearance="outline" color="accent" class="half-width">
        <mat-label>Nom</mat-label>
        <input matInput formControlName="nom" maxlength="120">
        <mat-error *ngIf="form.get('nom')?.hasError('required')">Champ obligatoire</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" color="accent" class="half-width">
        <mat-label>Prénom</mat-label>
        <input matInput formControlName="prenom" maxlength="120">
        <mat-error *ngIf="form.get('prenom')?.hasError('required')">Champ obligatoire</mat-error>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" color="accent" class="full-width">
      <mat-label>Poste(s)</mat-label>
      <mat-select formControlName="posteIds" multiple [disabled]="postesLoading">
        <mat-option *ngFor="let poste of postes" [value]="poste.posteId">
          {{ poste.libelle }}<span *ngIf="!poste.active"> (inactif)</span>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" color="accent" class="full-width">
      <mat-label>Commentaire</mat-label>
      <textarea matInput formControlName="commentaire" rows="3"></textarea>
    </mat-form-field>

    <div class="cv-section">
      <app-file-input
        [label]="isEditMode ? 'Remplacer le CV (PDF)' : 'CV (PDF) *'"
        placeholder="Sélectionner un fichier PDF..."
        hint="5 Mo maximum"
        (contentChange)="onCvSelected($event)">
      </app-file-input>

      <div class="cv-current" *ngIf="isEditMode && data?.hasCv && !cvFile">
        <mat-icon>picture_as_pdf</mat-icon>
        <span>Un CV est déjà enregistré pour ce collaborateur.</span>
      </div>

      <div class="cv-warning" *ngIf="!isEditMode && !cvFile">
        <mat-icon>info</mat-icon>
        <span>Le CV est obligatoire à la création.</span>
      </div>
    </div>

  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="onCancel()">Annuler</button>
  <button mat-raised-button color="primary"
          type="button"
          (click)="onSubmit()"
          [disabled]="form.invalid || isSubmitting || cvIsRequired">
    <mat-icon>{{ isEditMode ? 'save' : 'add' }}</mat-icon>
    {{ isEditMode ? 'Modifier' : 'Créer' }}
  </button>
</mat-dialog-actions>
